import { AbstractPinFactory } from "./AbstractPinFactory";

class TearDropPinFactory extends AbstractPinFactory {
  constructor() {
    const shadow = `<filter id='shadow' color-interpolation-filters="sRGB" height="140%" width="140%" x="-20%">
    <feDropShadow dx="0" dy="6" stdDeviation="4" flood-opacity="0.2"/>
  </filter>`;

    super({
      originalWidth: 46,
      originalHeight: 56,
      shadowWidth: 10,
      shadowHeight: 10,
      desiredScaledWidth: 46,
      shadow: shadow,
      iconOffsetX: 0,
      iconOffsetY: -10,
    });
  }

  getPaths(color: string) {
    return `<path  fill="${color}" filter="url(#shadow)" d="M22.9999 0C10.6295 0 0.56543 10.0641 0.56543 22.4345V23.0546C0.56543 29.3109 4.15227 36.6014 11.2266 44.7232C16.355 50.6111 21.4118 54.7166 21.6244 54.8885L22.9999 56L24.3754 54.8886C24.5881 54.7167 29.6448 50.6112 34.7731 44.7233C41.8474 36.6014 45.4343 29.311 45.4343 23.0547V22.4346C45.4343 10.0641 35.3703 0 22.9999 0Z"/>`;
  }
}

const tearDropPinFactory = new TearDropPinFactory();
export { tearDropPinFactory };
